import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Home } from './pages/Home'
import { HowWeHelp } from './pages/HowWeHelp'
import { HowItWorks } from './pages/HowItWorks'
import { Pricing } from './pages/Pricing'
import { About } from './pages/About'
import { FAQ } from './pages/FAQ'
import { TreatmentBudget } from './pages/PatientGuides'
import { FitCheck } from './pages/FitCheck'
import { LegalPage } from './pages/LegalPage'
import { NotFound } from './pages/NotFound'
import { News, NewsArticle, newsArticles } from './pages/News'
import config from './seo-pages.json'
import { newsArchivePages, newsPagePath } from './news-pagination'

// Public HTML stays synchronous for prerendering. Management tools load only
// when their own routes are opened, rather than on every patient-facing page.
const Analytics = lazy(() => import('./pages/Analytics').then(module => ({ default: module.Analytics })))
const Enquiries = lazy(() => import('./pages/Enquiries').then(module => ({ default: module.Enquiries })))
const Events = lazy(() => import('./pages/Events').then(module => ({ default: module.Events })))

export function AppRoutes() {
  return <Routes>
    <Route path="admin/analytics" element={<Suspense fallback={<p role="status">Loading analytics…</p>}><Analytics /></Suspense>} />
    <Route path="admin/enquiries" element={<Suspense fallback={<p role="status">Loading enquiries…</p>}><Enquiries /></Suspense>} />
    <Route path="admin/events" element={<Suspense fallback={<p role="status">Loading events…</p>}><Events /></Suspense>} />
    <Route element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="how-we-help" element={<HowWeHelp />} />
      <Route path="how-it-works" element={<HowItWorks />} />
      <Route path="pricing" element={<Pricing />} />
      <Route path="about" element={<About />} />
      <Route path="faq" element={<FAQ />} />

      <Route path="treatment-in-china-costs" element={<TreatmentBudget />} />
      <Route path="news" element={<News />} />
      {newsArchivePages(newsArticles.length).map(page => <Route key={page} path={newsPagePath(page).slice(1)} element={<News page={page} />} />)}
      {newsArticles.map(story => <Route key={story.slug} path={`news/${story.slug}`} element={<NewsArticle story={story} />} />)}
      <Route path="enquiry" element={<FitCheck />} />
      <Route path="privacy" element={<LegalPage type="privacy" />} />
      <Route path="terms" element={<LegalPage type="terms" />} />
      <Route path="disclaimer" element={<LegalPage type="disclaimer" />} />
      {Object.entries(config.redirects).map(([path, to]) => <Route key={path} path={path.slice(1)} element={<Navigate to={to} replace />} />)}
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
}
